export enum NavItemsEnum {
    default = 'DEFAULT',
    needToAddClientList = 'NEED_TO_ADD_CLIENT_LIST',
    needToAddBecomeAgent = 'NEED_TO_ADD_BECOME_AGENT',
    needToAddInviteAgent = 'NEED_TO_ADD_INVITE_AGENT',
    needToSpecialPartyRole = 'NEED_TO_ADD_SPECIAL_PARTY_ROLE',
    needToMain = 'NEED_TO_MAIN',
    notShow = 'NOT_SHOW',
}
